import { render, staticRenderFns } from "./btn_component_avatar_text.vue?vue&type=template&id=15468867&scoped=true"
import script from "./btn_component_avatar_text.vue?vue&type=script&lang=js"
export * from "./btn_component_avatar_text.vue?vue&type=script&lang=js"
import style0 from "./btn_component_avatar_text.vue?vue&type=style&index=0&id=15468867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15468867",
  null
  
)

export default component.exports